import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../services/dashboard.service';

import { indexOf } from "lodash";

declare var Highcharts: any;
declare var $: any;

@Component({
  selector: 'app-display-dashboard',
  templateUrl: './display-dashboard.component.html',
  styleUrls: ['./display-dashboard.component.css']
})
export class DisplayDashboardComponent implements OnInit, OnDestroy{

  constructor(public dashboardService: DashboardService, private router:Router) {
    this.futureCurveImageURL = dashboardService.getFutureCurveImageURL();
  }
  currentRoute: string = '';
  date:any;
  isPrint: boolean = false;
  displayChart: boolean = false;
  latestInventory: any;
  subscription: any;
  gaugeData: any;
  mapShown: string = 'Departure From Normal';
  _chartOptions : any;
  heatMapColors = ['#003c56','#006997','#0096d7','#4db6e3','#99d5ef','#AFAFAF','#e5c799','#d19d69','#bd732a','#84511d','#4c2e11']; //used in the view to render legend color boxes
  //heatMapColors = ['#1D3159','#305194','#4B74C5','#84A0D8','#BFCEEB','#AFAFAF','#F8D1B6','#F2A36E','#EB7829','#B75411','#70330A']; //used in the view to render legend color boxes
  futureCurveImageURL : string;
  departureHeatMap: any;
  departurePriorHeatMap: any;






  ngOnInit() {
    this.isPrint = window.matchMedia('print').matches;
    this.currentRoute = this.router.url;
    if(this.currentRoute.indexOf('?') > -1) {
      this.currentRoute = this.currentRoute.split('?')[0];
    }

    this.departureHeatMap = [
        {color : '#003c56', label : "<= -20" , topLabel : '°F below normal', upper: "<= -20", lower: ""},
        {color : '#006997', label : "-19 - -15" ,lower: "-19", upper: "-15" },
        {color : '#0096d7', label : "-14 to -10",lower: "-14", upper: "-10" },
        {color : '#4db6e3', label : "-9 to -5",lower: "-9", upper: "-5" },
        {color : '#99d5ef', label : "-4 to -1" ,lower: "-4", upper: "-1"},
        {color : '#AFAFAF', label : "0" , topLabel : 'normal', lower: '', upper: '0' },
        {color : '#e5c799', label : "1 to 5" ,lower: "1", upper: "4"},
        {color : '#d19d69', label : "6 to 10" ,lower: "5", upper: "9"},
        {color : '#bd732a', label : "11 to 15" ,lower: "10", upper: "14"},
        {color : '#84511d', label : "16 to 19" ,lower: "15", upper: "19"},
        {color : '#4c2e11', label : ">= 20" , topLabel : '°F above normal' ,lower: ">= 20", upper: ""}
    ];

    this.departurePriorHeatMap = [
        {color : '#003c56', label : "<= -20" , topLabel : '  ', upper: "<= -20", lower: ""},
        {color : '#006997', label : "-19 - -15" ,lower: "-19", upper: "-15" },
        {color : '#0096d7', label : "-14 to -10",lower: "-14", upper: "-10" },
        {color : '#4db6e3', label : "-9 to -5",lower: "-9", upper: "-5" },
        {color : '#99d5ef', label : "-4 to -1" ,lower: "-4", upper: "-1"},
        {color : '#AFAFAF', label : "0" , lower: '', upper: '0' },
        {color : '#e5c799', label : "1 to 5" ,lower: "1", upper: "4"},
        {color : '#d19d69', label : "6 to 10" ,lower: "5", upper: "9"},
        {color : '#bd732a', label : "11 to 15" ,lower: "10", upper: "14"},
        {color : '#84511d', label : "16 to 19" ,lower: "15", upper: "19"},
        {color : '#4c2e11', label : ">= 20" , topLabel : 'weekly difference (°F)' ,lower: ">= 20", upper: ""}
    ];


      $('.notesAndSources').fancybox({
          maxWidth	: 800,
          maxHeight	: 800,
          fitToView	: false,
          width		: '70%',
          type: 'iframe',
          //height	: '85%',
          //autoSize	: false,
          //autoHeight: true,
          closeClick	: false,
          openEffect	: 'none',
          closeEffect	: 'none',
      });

    Highcharts.setOptions({
      exporting : {
        buttons : {
          contextButton : {
            text : null
          }
        }
      }
    });
    this.latestInventory = {};
    this.gaugeData = [];
    this.subscription = this.dashboardService.getLatestInventory().subscribe(
      json =>{
        this.latestInventory = json;
      }, null, () =>{
            this.displayChart = true;
      });
  }

  public getAbsoluteNetChange() {
    return Math.abs(this.latestInventory.net_change);
  }

  public getNetChangeSign() {
    return (this.latestInventory.net_change > 0) ? 'positive' : (this.latestInventory.net_change < 0 ? 'negative' : '');
  }

  public showMap(id) {
    this.mapShown = id;
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  public showNational() {
    return this.isPrint || this.currentRoute == '/';
  }

  public showRegional() {
    return this.isPrint || this.currentRoute == '/regional';
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/display-dashboard/display-dashboard.component.ts